type Props = {
  className?: string;
};

export const Moon = (props: Props) => {
  const { className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fill="#D6B27D"
        d="M10.127 4.06a11.307 11.307 0 0 0 8.695 13.646 8.334 8.334 0 0 1-5.981 2.543c-.104 0-.209.003-.314 0a8.32 8.32 0 0 1-2.4-16.188m1.108-1.811a.75.75 0 0 0-.131.012 9.822 9.822 0 0 0 1.369 19.486c.122.004.245 0 .367 0a9.803 9.803 0 0 0 8.027-4.167.758.758 0 0 0-.587-1.173 9.81 9.81 0 0 1-8.363-13.123.761.761 0 0 0-.682-1.035z"
      />
    </svg>
  );
};
